import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-add-ai-credit',
  templateUrl: './add-ai-credit.component.html',
  styleUrl: './add-ai-credit.component.scss'
})
export class AddAiCreditComponent {
    amount = 5;

    constructor(
        public dialogRef: MatDialogRef<AddAiCreditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    setAmount(value: number): void {
        this.amount = value;
    }

    onOk(): void {
        this.dialogRef.close(this.amount);  // You can pass any result back
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
